import { getStore } from 'cadenza/store/cadenza-store';
import { showConfirmSaveAndExecuteDialog } from 'cadenza/workbook/confirm-save-and-execute-dialog/confirm-save-published-workbook';
import {
  executeSaveAsAction,
  executeSaveWorkbook,
} from 'cadenza/workbook/header/save-workbook-actions/save-workbook-actions';
import { isSaveAsButtonVisible } from 'cadenza/workbook/state/workbook-header';

/**
 * Confirms whether to save the workbook before executing an action.
 * @param {boolean} promptToSave - Whether to prompt the user to save the workbook.
 * @param {Function} actionCallback - The action to execute.
 * @returns A promise that resolves with the result of the action callback or undefined if the save is cancelled or fails.
 */
export async function confirmSaveWorkbookBeforeAction(promptToSave: boolean, actionCallback: () => Promise<unknown>) {
  if (promptToSave) {
    const shouldSave = await showConfirmSaveAndExecuteDialog();
    if (shouldSave) {
      if (!(await executeWorkbookSaveOrSaveAs())) {
        // save cancelled or failed
        return;
      }
    } else {
      return shouldSave;
    }
  }
  return actionCallback();
}

async function executeWorkbookSaveOrSaveAs() {
  try {
    if (isSaveAsButtonVisible(getStore().getState())) {
      return await executeSaveAsAction();
    }
    await executeSaveWorkbook();
    return true;
  } catch {
    return;
  }
}
